import script from "./supplement.vue?vue&type=script&setup=true&lang=js"
export * from "./supplement.vue?vue&type=script&setup=true&lang=js"

import "./supplement.vue?vue&type=style&index=0&id=07dc7a1c&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07dc7a1c"]])

export default __exports__